import axios from 'axios'

import { mapaprop } from '@/environment'
import operationNames from '@/helpers/operationNames'
import { IMapapropMessagesBody, IMapapropPropertiesQueries, IMapapropSuggestionsQueries } from '@/interfaces/mapaprop'
import { createLogger } from 'vuex'
import store from '@/store'
import { propertyHit } from '@/services/propertyApi'

axios.defaults.baseURL = mapaprop.baseURL
axios.defaults.headers.common['Authorization'] = `Bearer ${mapaprop.token}`

export const properties = async (queries: IMapapropPropertiesQueries) => {
  const params = new URLSearchParams()
  // console.group("ApiMapaprop: properties()");
  // console.log(queries)
  // console.groupEnd()

  if (queries.term) params.append('term', queries.term)
  if (queries.type) params.append('type', queries.type.toString())
  if (queries.operation) params.append('operation', queries.operation.toString())
  if (queries.from) params.append('from', queries.from.toString())
  if (queries.size) params.append('size', queries.size.toString())
  if (queries.bedrooms) params.append('bedrooms', queries.bedrooms.toString())
  if (queries.bathrooms) params.append('bathrooms', queries.bathrooms.toString())
  if (queries.stateId) params.append('stateId', queries.stateId.toString())
  if (queries.countyId) params.append('countyId', queries.countyId.toString())
  if (queries.cityId) params.append('cityId', queries.cityId.toString())
  if (queries.buildingStatus) params.append('buildingStatus', queries.buildingStatus.toString())
  if (queries.tempOccupancy) params.append('tempOccupancy', queries.tempOccupancy.toString())
  if (queries.dateFrom) params.append('dateFrom', queries.dateFrom)
  if (queries.dateTo) params.append('dateTo', queries.dateTo)
  if (queries.priceFrom) params.append('priceFrom', queries.priceFrom.toString())
  if (queries.priceTo) params.append('priceTo', queries.priceTo.toString())
  if (queries.currency) params.append('currency', queries.currency.toString())
  params.append('oauth_token', mapaprop.token)

    const country = store.getters['countries/country'].code.toUpperCase()
    //console.log('country:', country)

  const axiosGet = axios.get(`properties/${country}/?${params.toString()}`).then((response) => {
      response.data.filters = []
      if (queries.operation) response.data.filters.push({ operation: { id: queries.operation } })
      if (queries.type) response.data.filters.push({ type: { id: queries.type } })
      if (queries.currency) response.data.filters.push({ currency: { id: queries.currency, name: queries.currency } })
      if (queries.priceFrom) response.data.filters.push({ priceFrom: { id: queries.priceFrom, name: queries.priceFrom } })
      if (queries.priceTo) response.data.filters.push({ priceTo: { id: queries.priceTo, name: queries.priceTo } })
      if (queries.bedrooms) response.data.filters.push({ bedrooms: { id: queries.bedrooms, name: queries.bedrooms } })
      if (queries.bathrooms) response.data.filters.push({ bathrooms: { id: queries.bathrooms, name: queries.bathrooms } })
      return response
      console.log(response)
  })

  //console.group("ApiMapaprop: axios.get")
  // console.log('Params: ', params.toString())
  //axios.get(`properties?${params.toString()}`).then(function (response){
   // console.log(response)
  //}).catch(function(err){
  //console.error(err)
  //});
  // console.groupEnd()

  return axiosGet;
}

export const getProperties = async (url: string, country: any) => {
  const params = new URLSearchParams()

  params.append('oauth_token', mapaprop.token)

  return axios
    .post(`sitemap/search-url/${country.code.toLowerCase()}?url=${url}&${params.toString()}`)
    .then(response => {
       // console.log(response)
    })
    .catch((error) => {
      console.error(error)
    })
}

export const property = async (propertyHash: string) => {
    const params = new URLSearchParams()

    params.append('oauth_token', mapaprop.token)
    const response = await axios.get(`properties/${propertyHash}?${params.toString()}`)
    propertyHit(response.data.customerId, response.data.propertyId, window.location.href)
    return response
}

export const operations = async (country: string) => {
  const params = new URLSearchParams()

  params.append('oauth_token', mapaprop.token)
  return axios.get(`settings/operations/${country}?${params.toString()}`)
}

export const types = async (country: string) => {
  const params = new URLSearchParams()

  params.append('oauth_token', mapaprop.token)

  return axios.get(`settings/types/${country}?${params.toString()}`)
}

export const filters = async (country: string) => {
  const params = new URLSearchParams()

  params.append('oauth_token', mapaprop.token)

  return axios.get(`zones/filters?${params.toString()}`)
}

export const suggestions = async (queries: IMapapropSuggestionsQueries) => {
  const params = new URLSearchParams({})

  if (queries.term) params.append('term', queries.term)
  if (queries.country) params.append('country', queries.country)
  if (queries.limit) params.append('limit', queries.limit.toString())
  params.append('oauth_token', mapaprop.token)

  return axios.get(`zones/suggestions?${params.toString()}`)
}

export const messages = async (body: IMapapropMessagesBody) => {
  const params = new URLSearchParams()

  if (body.email) params.append('email', body.email)
  if (body.ip) {
    params.append('ip', body.ip)
  } else {
    params.append('ip', '10.0.2.1975')
  }
  if (body.message) params.append('message', body.message)
  if (body.name) params.append('name', body.name)
  if (body.phone) params.append('phone', body.phone)
  if (body.propertyHash) params.append('propertyHash', body.propertyHash)
  if (body.referer) params.append('referer', body.referer)
  if (body.url) params.append('url', body.url)
  if (body.userAgent) params.append('userAgent', body.userAgent)

  params.append('oauth_token', mapaprop.token)

  return axios.post(`messages?${params.toString()}`)

}
